/* ============================================================
   Wishlist / Favoris — behaviour
   - Stores favorites in localStorage (no account needed)
   - Injects a heart on product cards and the header
   - Renders the dedicated WhishList page
   ============================================================ */
(function () {
  'use strict';

  var STORAGE_KEY = 'savor:wishlist';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';

  var LABEL_ADD = 'Ajouter aux favoris';
  var LABEL_REMOVE = 'Retirer des favoris';

  function getLabels(btn) {
    var add = (btn && btn.getAttribute('data-label-add')) || (document.body && document.body.dataset.wishlistLabelAdd) || LABEL_ADD;
    var remove = (btn && btn.getAttribute('data-label-remove')) || (document.body && document.body.dataset.wishlistLabelRemove) || LABEL_REMOVE;
    return { add: add, remove: remove };
  }

// Outline/solid heart. Fill is controlled via CSS (.is-active => filled).
  var HEART_SVG =
    '<span class="wishlist-heart" aria-hidden="true">' +
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none" width="20" height="20">' +
    '<path d="M17 6.352C17 3.94667 15.0053 2 12.5467 2C11.096 2 9.81067 3.49333 9 4.53867C8.18933 3.49333 6.89867 2 5.45333 2C2.99467 2 1 3.94667 1 6.352C1 7.38133 1.368 8.32533 1.976 9.072L1.992 9.09333C2.06133 9.17333 9.00533 16.9333 9.00533 16.9333L16.024 9.072C16.632 8.32533 17 7.38133 17 6.352Z" ' +
    'stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg></span>';

  /* ---------- store ---------- */
  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr.filter(Boolean) : [];
    } catch (e) {
      return [];
    }
  }
  function write(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
  }
  function has(handle) {
    return read().indexOf(handle) !== -1;
  }
  function toggle(handle) {
    var list = read();
    var i = list.indexOf(handle);
    var added = i === -1;
    if (added) list.push(handle);
    else list.splice(i, 1);
    write(list);
    document.dispatchEvent(
      new CustomEvent('wishlist:change', { detail: { handle: handle, added: added, list: read() } })
    );
    return added;
  }

  /* ---------- helpers ---------- */
  function handleFromUrl(url) {
    if (!url) return null;
    var m = url.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function makeButton(handle, variant) {
    var labels = getLabels();
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'wishlist-toggle wishlist-toggle--' + variant;
    btn.setAttribute('data-wishlist-toggle', '');
    btn.setAttribute('data-product-handle', handle);
    btn.setAttribute('data-label-add', labels.add);
    btn.setAttribute('data-label-remove', labels.remove);
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', labels.add);
    btn.innerHTML = HEART_SVG + '<span class="wishlist-toggle__label">' + labels.add + '</span>';
    return btn;
  }

  function syncButton(btn) {
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    var labels = getLabels(btn);
    var active = has(handle);
    btn.classList.toggle('is-active', active);
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute('aria-label', active ? labels.remove : labels.add);
    var label = btn.querySelector('.wishlist-toggle__label');
    if (label && !label.classList.contains('visually-hidden')) {
      label.textContent = active ? labels.remove : labels.add;
    }
  }

  function syncAllButtons() {
    var btns = document.querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < btns.length; i++) syncButton(btns[i]);
  }

  function updateCount() {
    var n = read().length;
    var counts = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < counts.length; i++) counts[i].textContent = n > 99 ? '99+' : n;
    var bubbles = document.querySelectorAll('[data-wishlist-bubble]');
    for (var j = 0; j < bubbles.length; j++) bubbles[j].classList.toggle('is-empty', n === 0);
  }

  /* ---------- header heart ---------- */
  function injectHeader() {
    var actionsList = document.querySelectorAll('header-actions');
    for (var i = 0; i < actionsList.length; i++) {
      var actions = actionsList[i];
      if (actions.querySelector('[data-wishlist-link]')) continue;

      var link = document.createElement('a');
      link.href = root + 'pages/wishlist';
      link.className = 'header-actions__action header-actions__wishlist-icon';
      link.setAttribute('data-wishlist-link', '');
      link.setAttribute('aria-label', 'Mes favoris');
      link.innerHTML =
        '<span class="svg-wrapper">' +
        HEART_SVG +
        '</span>' +
        '<span class="wishlist-bubble is-empty" data-wishlist-bubble>' +
        '<span class="wishlist-bubble__text" data-wishlist-count>0</span>' +
        '</span>';

      var cart = actions.querySelector('.action__cart, cart-drawer, cart-icon');
      if (cart && cart.parentNode === actions) {
        actions.insertBefore(link, cart);
      } else if (cart) {
        var node = cart;
        while (node.parentNode && node.parentNode !== actions) node = node.parentNode;
        if (node.parentNode === actions) actions.insertBefore(link, node);
        else actions.appendChild(link);
      } else {
        actions.appendChild(link);
      }
    }
  }

  /* ---------- product card hearts ---------- */
  function injectCards() {
    var cards = document.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector('[data-wishlist-toggle]')) continue;
      var a = card.querySelector('a.product-card__link, a[href*="/products/"]');
      var handle = a ? handleFromUrl(a.getAttribute('href')) : null;
      if (!handle) continue;
      var btn = makeButton(handle, 'card');
      card.appendChild(btn);
      syncButton(btn);
    }
  }

  /* ---------- product page heart (disabled — use card overlay icons only) ---------- */

  /* ---------- wishlist page ---------- */
  function money(cents) {
    try {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: cur
      }).format((cents || 0) / 100);
    } catch (e) {
      return ((cents || 0) / 100).toFixed(2);
    }
  }

  function cardHTML(p) {
    var labels = getLabels();
    var img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) {
      img = img.replace(/(\.[a-zA-Z]+)(\?.*)?$/, function (all, ext, q) {
        return '_600x' + ext + (q || '');
      });
    }
    var url = root + 'products/' + p.handle;
    var price = money(p.price);
    return (
      '<div class="wishlist-card">' +
      '<a class="wishlist-card__media" href="' + url + '">' +
      (img ? '<img loading="lazy" src="' + img + '" alt="' + (p.title || '').replace(/"/g, '&quot;') + '">' : '') +
      '</a>' +
      '<button type="button" class="wishlist-toggle wishlist-toggle--card is-active" data-wishlist-toggle data-product-handle="' +
      p.handle + '" data-label-add="' + labels.add + '" data-label-remove="' + labels.remove + '" aria-pressed="true" aria-label="' + labels.remove + '">' + HEART_SVG +
      '<span class="wishlist-toggle__label">' + labels.remove + '</span></button>' +
      '<a class="wishlist-card__link" href="' + url + '">' +
      '<div class="wishlist-card__collection">WIGZ LAB HD LACE™</div>' +
'<div class="wishlist-card__title">' + (p.title || '') + '</div>' +
      '</a>' +
      '<div class="wishlist-card__price">' + price + '</div>' +
      '</div>'
    );
  }

  var rendering = false;
  function renderWishlistPage() {
    var grid = document.getElementById('wishlist-grid');
    if (!grid) return;
    var empty = document.getElementById('wishlist-empty');
    var list = read();

    if (!list.length) {
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    if (rendering) return;
    rendering = true;

    Promise.all(
      list.map(function (handle) {
        return fetch(root + 'products/' + handle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      rendering = false;
      var valid = products.filter(Boolean);
      if (valid.length !== list.length) {
        write(valid.map(function (p) { return p.handle; }));
        updateCount();
      }
      grid.innerHTML = valid.map(cardHTML).join('');
    });
  }

  /* ---------- events ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    if (handle) toggle(handle);
  });

  document.addEventListener('wishlist:change', function () {
    updateCount();
    syncAllButtons();
    renderWishlistPage();
  });

  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) {
      updateCount();
      syncAllButtons();
      renderWishlistPage();
    }
  });

  function refresh() {
    injectHeader();
    injectCards();
    updateCount();
    syncAllButtons();
  }

  function init() {
    refresh();
    renderWishlistPage();

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        refresh();
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
